<div class="d-flex">
	<mat-card class="w-50 m-2">
		<mat-card-header>
			<mat-card-title>Grupy</mat-card-title>
		</mat-card-header>
		<mat-card-content style="height: calc(100vh - 330px)">
			<div
				class="pe-5 m-0 w-100 h-100 overflow-auto"
				appInfiniteScroll
				[threshold]="50"
				(scrolledToEnd)="loadMoreGroups()"
			>
				@for (item of checklistGroups()?.groups ?? []; track item.id) {
					<div class="d-flex flex-column">
						<span
							class="d-flex justify-content-between align-items-center"
							role="button"
							(click)="changeShowState(item.id)"
							><mat-checkbox
								[disabled]="editable()"
								color="primary"
								[checked]="item.selected"
								(click)="$event.stopPropagation()"
								(change)="updateGroupsSelection($event.checked, item.id)"
								>{{ item.name }}
							</mat-checkbox>
							<i class="fa-solid fa-angle-down" [ngClass]="{ 'rotate-vertically': item.showActions }"></i>
						</span>
						<ul [ngClass]="{ 'd-none ': !item.showActions }" style="font-size: 0.9rem; color: #757575">
							@for (action of item.actions; track action.id) {
								<li>{{ $index + 1 }}. {{ action.name }}</li>
							}
						</ul>
					</div>
				}
			</div>
		</mat-card-content>
	</mat-card>

	<mat-card class="w-50 m-2">
		<mat-card-header>
			<mat-card-title>Akcje</mat-card-title>
		</mat-card-header>
		<mat-card-content style="height: calc(100vh - 330px)">
			<ul class="pe-5 m-0 w-100 h-50 overflow-auto">
				@for (item of unassignedChecklists(); track item.id) {
					<li>
						<mat-checkbox
							[disabled]="editable()"
							color="primary"
							[checked]="item.selected"
							(change)="updateUnassignedItemsSelection($event.checked, item.id)"
						>
							{{ item.name }}
						</mat-checkbox>
					</li>
				}
			</ul>
			<mat-divider></mat-divider>
			<ul
				appInfiniteScroll
				[threshold]="50"
				(scrolledToEnd)="loadMoreAssignedItems()"
				class="pe-5 m-0 w-100 h-50 overflow-auto"
			>
				@for (item of assignedChecklists()?.items ?? []; track item.id) {
					<li>
						<mat-checkbox
							[disabled]="editable() || item.disabled"
							color="primary"
							[checked]="item.selected"
							(change)="updateAssignedItemsSelection($event.checked, item.id)"
						>
							{{ item.name }}
						</mat-checkbox>
					</li>
				}
			</ul>
		</mat-card-content>
	</mat-card>
</div>
